import { MinerLocationRaw } from "@services/getMinerList";
import { ILocationForList } from "@services/locations";
import { RootState } from "@store";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

export const useMinerLocations = (): ILocationForList[] => {
  return useSelector((state: RootState) => state.locations.locations);
};

const createLocationSelector = () => {
  const selector = (state: RootState) => state.locations.locations;
  return selector;
};

export const useMinerLocationsRaw = (): MinerLocationRaw[] => {
  const selector = createLocationSelector();
  const reselect = createSelector(selector, (locations) => {
    return (locations || []).map((loc) => ({
      id: loc.Id,
      location_id: loc.Code, //LocId,
      name: loc.Name,
      address: loc.Address,
    }));
  });

  return useSelector(reselect);
};
